import { useState } from 'react';
import { TableInput } from '../../../../../components/common';

interface Ifoot {
  moduleData: any;
  isView: boolean;
}
const TFoot = ({ moduleData, isView }: Ifoot) => {
  const [render, setRender] = useState(false);

  return (
    <tfoot>
      <tr style={{ background: '#a9e34b' }}>
        <th colSpan={35} align="left">
          Remarks :
          <TableInput
            isView={isView}
            name="remarks"
            type="text"
            value={moduleData?.remarks}
            onChange={(e) => {
              moduleData.remarks = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr style={{ background: '#a9e34b' }}>
        <th colSpan={35} align="left">
          Prepared By :
          <TableInput
            isView={isView}
            name="prepared_by"
            type="text"
            value={moduleData?.prepared_by}
            onChange={(e) => {
              moduleData.prepared_by = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr style={{ background: '#a9e34b' }}>
        <th colSpan={35} align="left">
          Approved By :
          <TableInput
            isView={isView}
            name="approved_by"
            type="text"
            value={moduleData?.approved_by}
            onChange={(e) => {
              moduleData.approved_by = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
